module.exports = __webpack_public_path__ + "static/media/71530014-UvE0wSgs.1709f608.JPG";